import SingleSelect from './src/single-select';

export default SingleSelect;
